import { Switch, Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";
import { postTrack } from "../../../services/trackService";
import useGetValidAccessToken from "../../../hooks/useGetValidAccessToken";
import { Dispatch, SetStateAction, useContext } from "react";
import { Track, TrackState } from "../../../proto/api_pb";
import { TrackObj, VersionAction } from "../../../pages/MyTracks/types";
import { AuthContext, AuthContextInterface } from "../../../contexts";

interface TrackPrivacySwitchProps {
  isTrackPublished: boolean;
  isTrackConnectedToTutorial: boolean;
  track: Track | undefined;
  setIsTrackPublished: Dispatch<SetStateAction<boolean>>;
  handleOpenPublishModal: ((id: string) => void) | undefined;
  upsertTrackInState: ((trackToUpsert: TrackObj) => void) | undefined;
}

export const TrackPrivacySwitch: React.FC<TrackPrivacySwitchProps> = ({
  isTrackPublished,
  isTrackConnectedToTutorial,

  track,
  setIsTrackPublished,
  handleOpenPublishModal,
  upsertTrackInState,
}) => {
  const { getValidAccessToken } = useGetValidAccessToken();
  const { userId } = useContext<AuthContextInterface>(AuthContext);

  const updateTrackPrivacy = async () => {
    try {
      if (track) {
        setIsTrackPublished(false);
        track.setState(TrackState.TRACK_STATE_DRAFT);
        await postTrack(track, await getValidAccessToken(), userId);
        if (upsertTrackInState) {
          upsertTrackInState({
            track: track,
            trackUrl: "",
            isPlaying: false,
            versionCount: VersionAction.TrackEdited,
            latestVersion: undefined,
            notifications: undefined,
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Tooltip title={isTrackPublished ? "Public" : "Private"}>
        <span style={{ fontSize: "12px", marginLeft: "15px" }}>
          {isTrackPublished ? "Public" : "Private"}
          <IconButton
            id={isTrackConnectedToTutorial ? "step-12" : ""}
            disableRipple
            onClickCapture={(e) => {
              e.stopPropagation();
              if (!isTrackPublished && handleOpenPublishModal && track) {
                handleOpenPublishModal(track.getId());
              } else {
                updateTrackPrivacy();
              }
            }}
            sx={{ color: "white", zIndex: 1000 }}
          >
            <Switch
              checked={isTrackPublished}
              inputProps={{ "aria-label": "controlled" }}
            />
          </IconButton>
        </span>
      </Tooltip>
    </>
  );
};
